import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Dashboard from './pages/Dashboard/Dashboard';
import CSIP from './pages/CSIP/CSIP';
import Login from './pages/Login';
import CSIPEdit from './pages/CSIPEdit/CSIPEdit';
import ISSLC from './pages/ISSLC/ISSLC';
import ISSLCSchool from './pages/ISSLCSchool/ISSLCSchool';
import ISSLCEdit from './pages/ISSLC-edit/ISSLC-edit';
import Users from './pages/Users/Users';
import UsersEdit from './pages/Users-edit/Users-edit';
import UserNew from './pages/User-new/User-new';
import AWSPEdit from './pages/AWSPEdit/AWSPEdit';
import ISSLCSchoolColumnEdit from './pages/ISSLCSchoolColumnEdit/ISSLCSchoolColumnEdit';
import { CSIPElementarySchoolTemplate } from './pages/CSIPElementaryTemplate/CSIPElementaryTemplate';
import { CSIPHighSchoolTemplate } from './pages/CSIPHighSchoolTemplate/CSIPHighSchoolTemplate';
import { CSIPMiddleSchoolTemplate } from './pages/CSIPMiddleSchoolTemplate/CSIPMiddleSchoolTemplate';
import { CSIP8KSchoolTemplate } from './pages/CSIP8KSchoolTemplate/CSIP8KSchoolTemplate';
import React from 'react';

function App() {
    return (
        <Router>
            <div className={''}>
                <Switch>
                    <Route path={'/login'}>
                        <Login />
                    </Route>

                    {/* CSIP Part */}
                    <Route path={'/csip/elementary-template'}>
                        <CSIPElementarySchoolTemplate />
                    </Route>
                    <Route path={'/csip/high-school-template'}>
                        <CSIPHighSchoolTemplate />
                    </Route>
                    <Route path={'/csip/middle-school-template'}>
                        <CSIPMiddleSchoolTemplate />
                    </Route>
                    <Route path={'/csip/8-k-school-template'}>
                        <CSIP8KSchoolTemplate />
                    </Route>
                    <Route path={'/csip/:schoolId'} component={CSIPEdit}></Route>
                    <Route path={'/csip'}>
                        <CSIP />
                    </Route>

                    {/* ISSLC Part */}
                    <Route path={'/isslc-edit/:schoolId/:columnId/:rowId'} component={ISSLCEdit}></Route>
                    <Route path={'/isslc/edit-column/:schoolId/'} component={ISSLCSchoolColumnEdit}></Route>
                    <Route path={'/isslc/awsp-edit/:schoolId/:cellId'} component={AWSPEdit}></Route>
                    <Route path={'/isslc/:schoolId'} component={ISSLCSchool}></Route>
                    <Route path={'/isslc'}>
                        <ISSLC />
                    </Route>

                    {/* USERS Part */}
                    <Route path={'/users/:userId'} component={UsersEdit}></Route>
                    <Route path={'/users-new'} component={UserNew}></Route>

                    <Route path={'/users'}>
                        <Users />
                    </Route>

                    <Route path={'/'}>
                        <Dashboard />
                    </Route>
                </Switch>
            </div>
        </Router>
    );
}

export default App;
